/* Example Usage
    
    <PageHeader
        title={"Workshop Organizations"}
        cancel={this.cancel}
        actionButtons={[{ label: "Add new", action: this.onNew, disabled: true }]}
        errorDetails={{
            feedback: this.state.error,
            dismiss: this.hideError
        }}
    />

*   Parameters/Props:
        title:  string [required]
        cancel:  function [optional]
        actionButtons:  array (of button objects) [optional]
                        button: {
                            label: string [required]
                            action: function [optional] // If action is not present, the button type becomes "submit"
                            disabled: boolean [optional]
                        }
        errorDetails: object [optional]
*/

import React from 'react';
import withStyles from '@mui/styles/withStyles';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import { withTranslation } from 'react-i18next';
import styles from '../styles';
import { useHistory } from 'react-router';

import { Helmet } from 'react-helmet'

function PageHeader(props) {
    const {t} = props;
    const history = useHistory()

    return (
        <Box>
             <Helmet>
                <title>{ props.title }</title>
            </Helmet>
            <Box pb={3} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
                <Grid container spacing={3} justifyContent="space-between">
                    <Grid item>
                        <h2 className="page-heading">{props.title}</h2>
                    </Grid>
                    <Grid item>
                        <Grid container spacing={2} justifyContent="flex-start">
                            {props.cancel &&
                                <Grid item>
                                    {/* <Button variant="outlined" className={[].join(' ')} onClick={() => props.cancel()}>{props.t('pageHeader.back')}</Button> */}
                                    <Button variant="outlined" className={[].join(' ')} disabled={props.cancelDisabled || false} onClick={() => props.cancel()}> {t('back')} </Button>
                                </Grid>
                            }
                            {props.backButton &&
                                <Grid item>
                                    <Button variant="outlined" className={[].join(' ')} onClick={() => history.goBack()}> {t('back')} </Button>
                                </Grid>
                            }
                            {props.actionButtons && props.actionButtons.map((button) => (
                                <Grid item key={button.label}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={[].join(' ')}
                                        onClick={button.action || undefined}
                                        type={("action" in button) ? "" : "submit"}
                                        disabled={button.disabled || false}
                                    >
                                        {button.label}
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            {props.errorDetails && props.errorDetails.feedback &&
                <Box>
                    <Alert severity="error" onClose={() => props.errorDetails.dismiss()}>{props.errorDetails.feedback}</Alert>
                    <br />
                </Box>
            }
        </Box>
    );
}

export default withStyles(styles, { withTheme: true })(withTranslation()(PageHeader));
//export default withStyles(styles, { withTheme: true })(PageHeader);